import { useContext, useEffect, useState } from 'react';
import { Grid, useMediaQuery } from '@mui/material';

import {
    AnonymousUserContext,
    AnonymousUserContextType,
} from '../../../contexts/anonUser';
import { SessionContext, SessionContextType } from '../../../contexts/session';
import { breakpoint4 } from '../../../utils/layouts';
import OptionImg from '../OptionImg/OptionImg';
import OptionResults from '../OptionResults/OptionResults';
import VoteButton from './VoteButton/VoteButton';
import PollController from '../PollController';
import { PollRecord } from '../../../models/Poll';
import {
    UserActivityContext,
    UserActivityContextType,
} from '../../../contexts/userActivity';

interface PollOptionsProps {
    poll: PollRecord;
    setPoll: React.Dispatch<React.SetStateAction<PollRecord>>;
    mypoll?: boolean;
}

const PollOptions = (props: PollOptionsProps): JSX.Element => {
    const sessionContext = useContext<SessionContextType>(SessionContext);
    const anonymousUserContext =
        useContext<AnonymousUserContextType>(AnonymousUserContext);
    const mobileLandscapePlus = useMediaQuery(breakpoint4);
    const [voteEnabled, setVoteEnabled] = useState<boolean>(false);
    const { userActivity, setUserActivity } =
        useContext<UserActivityContextType>(UserActivityContext);

    useEffect(() => {
        const { session } = sessionContext;
        const { anonUser } = anonymousUserContext;

        // HP5
        setVoteEnabled(
            Boolean(
                (session.user &&
                    session.votes &&
                    !session.votes[props.poll.id]) ||
                    (!session.user &&
                        anonUser.acceptCookies &&
                        anonUser.user &&
                        anonUser.votes &&
                        !anonUser.votes[props.poll.id]),
            ),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sessionContext, anonymousUserContext]);

    const onVoteClickHandler = async (option: number): Promise<void> => {
        await PollController.processVote(
            props.poll,
            option,
            sessionContext,
            props.setPoll,
            anonymousUserContext,
            setVoteEnabled,
        );

        if (userActivity.activitySince > 0) {
            setUserActivity({ ...userActivity, votes: userActivity.votes + 1 });
        }
    };

    return (
        <Grid container spacing={2} className='poll-options'>
            <Grid item xs={mobileLandscapePlus ? 6 : 12}>
                <OptionImg poll={props.poll} option={1} />
                <OptionResults
                    poll={props.poll}
                    option={1}
                    mypoll={Boolean(props.mypoll)}
                />
                {/* HP5 */}
                <VoteButton
                    poll={props.poll}
                    option={1}
                    disabled={!voteEnabled || props.mypoll}
                    onClick={() => onVoteClickHandler(1)}
                />
            </Grid>
            <Grid item xs={mobileLandscapePlus ? 6 : 12}>
                <OptionImg poll={props.poll} option={2} />
                <OptionResults
                    poll={props.poll}
                    option={2}
                    mypoll={Boolean(props.mypoll)}
                />
                {/* HP5 */}
                <VoteButton
                    poll={props.poll}
                    option={2}
                    disabled={!voteEnabled || props.mypoll}
                    onClick={() => onVoteClickHandler(2)}
                />
            </Grid>
        </Grid>
    );
};

export default PollOptions;
